import { render, staticRenderFns } from "./NavtextContent.vue?vue&type=template&id=7c5b86be"
import script from "./NavtextContent.vue?vue&type=script&lang=js"
export * from "./NavtextContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports